module.exports = __webpack_public_path__ + "static/img/伙伴客户-美年.b487e39c.png";